/* eslint-disable no-param-reassign */
import { createAction } from '@reduxjs/toolkit';

import { setActiveTabByProductChannel, setSelectedChannelByProduct } from './helpers/uiAdapter';

export const setProductListingActiveTab = createAction('products/setProductListingActiveTab');

export const reducer = (builder) => {
  builder
    .addCase(setProductListingActiveTab, (state, { payload }) => {
      const { productId, channelId, tab } = payload;

      setActiveTabByProductChannel(state, productId, channelId, tab);
      setSelectedChannelByProduct(state, productId, channelId);
    });
};
